import { name } from "./block.json";

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block: HTMLDivElement) {
  console.log("init block");

	const wpBlockQuery = block.closest<HTMLDivElement>('.wp-block-query');

	if (!wpBlockQuery) {
		return;
	}

	const onButtonClick = (event) => {
		const button: HTMLButtonElement = event.target;
		const selector = button.dataset.selector;

		if (!selector) {
			return;
		}

		const checkFilters = () => {
			block.querySelectorAll<HTMLButtonElement>('.wp-block-site-post-taxonomy-filter__button.active').forEach((activeButton) => {
				activeButton.classList.remove('active')
			});

			button.classList.add('active');

			wpBlockQuery.querySelectorAll<HTMLLIElement>(`.wp-block-post:not(${selector})`).forEach((blockPost) => {
				blockPost.style.display = 'none';
			});

			wpBlockQuery.querySelectorAll<HTMLLIElement>(selector).forEach((blockPost) => {
				blockPost.style.display = '';
			});
		}

		if (!document.startViewTransition) {
			checkFilters();
			return;
		}

		document.startViewTransition(() => {
			checkFilters();
		});
	}

	wpBlockQuery
		.querySelectorAll<HTMLButtonElement>('.wp-block-site-post-taxonomy-filter__button')
		.forEach((button) => {
			button.addEventListener('click', onButtonClick)
		});
}
